import { WorkflowTemplateFormData } from '../hooks';

export const initialWorkflowTemplate: WorkflowTemplateFormData = {
  name: '',
  requiresName: false,
  components: [],
  archivedComponents: [],
  behavior: null,
  channelDefaultConfiguration: null,
};
